var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getColorMode } from '../../colorMode';
import { replaceInTemplate } from '../../utils/replace-in-template';
import { generateGUID } from '../../utils/generate-uuid';
import { toastTemplates } from './toast-templates';
let document;
if (typeof window !== 'undefined' && typeof window.document !== 'undefined') {
    document = window.document;
}
const EXPAND_AFTER = 5 * 1000;
let timeout;
let expandTimeout;
let globalToastConfig;
const createActionItem = (toastAction) => __awaiter(void 0, void 0, void 0, function* () {
    const { text, actionText, actionCallback } = toastAction;
    const id = yield generateGUID();
    const wrapper = document.createElement('div');
    wrapper.classList.add('beacon-toast__action__item');
    if (actionCallback) {
        wrapper.innerHTML = text.length > 0 ? `<p>${text}</p>` : ``;
        wrapper.innerHTML += `<p><a id="${id}">${actionText}</a></p>`;
    }
    else if (actionText) {
        wrapper.innerHTML =
            text.length > 0 ? `<p class="beacon-toast__action__item__subtitle">${text}</p>` : ``;
        wrapper.innerHTML += `<p>${actionText}</p>`;
    }
    else {
        wrapper.innerHTML = `<p>${text}</p>`;
    }
    if (actionCallback) {
        wrapper.addEventListener('click', actionCallback);
    }
    return wrapper;
});
const removeAllChildNodes = (parent) => {
    while (parent.firstChild) {
        parent.removeChild(parent.firstChild);
    }
};
const formatToastText = (html) => {
    var _a, _b;
    const walletIcon = (_a = globalToastConfig === null || globalToastConfig === void 0 ? void 0 : globalToastConfig.walletInfo) === null || _a === void 0 ? void 0 : _a.icon;
    const walletName = (_b = globalToastConfig === null || globalToastConfig === void 0 ? void 0 : globalToastConfig.walletInfo) === null || _b === void 0 ? void 0 : _b.name;
    let wallet = '';
    if (walletIcon) {
        wallet += `<span class="beacon-toast__wallet__container"><img class="beacon-toast__content__img" src="${walletIcon}">`;
    }
    if (walletName) {
        wallet += `<strong>${walletName}</strong></span>`;
    }
    else {
        wallet += `Wallet`;
    }
    return replaceInTemplate(html, 'wallet', wallet);
};
const getToastHTML = (config) => {
    const text = config.body;
    let html = replaceInTemplate(toastTemplates.default.html, 'text', text);
    html = formatToastText(html);
    return {
        style: toastTemplates.default.css,
        html
    };
};
/**
 * Close a toast
 */
const closeToast = () => new Promise((resolve) => {
    var _a;
    globalToastConfig = undefined;
    const wrapper = document.getElementById('beacon-toast-wrapper');
    if (!wrapper) {
        return resolve();
    }
    const elm = (_a = wrapper.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById('beacon-toast');
    if (elm) {
        const animationDuration = 300;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        elm.className = elm.className.replace('fadeIn', 'fadeOut');
        window.setTimeout(() => {
            const parent = wrapper.parentNode;
            if (parent) {
                parent.removeChild(wrapper);
            }
            resolve();
        }, animationDuration);
    }
    else {
        resolve();
    }
});
const registerClick = (shadowRoot, id, callback) => {
    const button = shadowRoot.getElementById(id);
    if (button) {
        button.addEventListener('click', () => __awaiter(void 0, void 0, void 0, function* () {
            yield callback(button);
        }));
    }
    return button;
};
const showElement = (shadowRoot, id) => {
    const el = shadowRoot.getElementById(id);
    if (el) {
        el.classList.remove('hide');
        el.classList.add('show');
    }
};
const hideElement = (shadowRoot, id) => {
    const el = shadowRoot.getElementById(id);
    if (el) {
        el.classList.add('hide');
        el.classList.remove('show');
    }
};
// const showLoader = (): void => {
//   showElement('beacon-toast-loader')
// }
const hideLoader = (shadowRoot) => {
    hideElement(shadowRoot, 'beacon-toast-loader');
    showElement(shadowRoot, 'beacon-toast-loader-placeholder');
};
// const showToggle = (): void => {
//   showElement('beacon-toast-button-expand')
//   hideElement('beacon-toast-button-close')
// }
const showClose = (shadowRoot) => {
    showElement(shadowRoot, 'beacon-toast-button-close');
    hideElement(shadowRoot, 'beacon-toast-button-expand');
};
const collapseList = (shadowRoot) => {
    const expandButton = shadowRoot.getElementById('beacon-toast-button-expand');
    const list = shadowRoot.getElementById('beacon-toast-list');
    if (expandButton && list) {
        expandButton.classList.remove('beacon-toast__upside_down');
        list.classList.add('hide');
        list.classList.remove('show');
    }
};
const expandList = (shadowRoot) => {
    const expandButton = shadowRoot.getElementById('beacon-toast-button-expand');
    const list = shadowRoot.getElementById('beacon-toast-list');
    if (expandButton && list) {
        expandButton.classList.add('beacon-toast__upside_down');
        list.classList.remove('hide');
        list.classList.add('show');
    }
};
const expandOrCollapseList = (shadowRoot) => {
    const expandButton = shadowRoot.getElementById('beacon-toast-button-expand');
    const list = shadowRoot.getElementById('beacon-toast-list');
    if (expandButton && list) {
        if (expandButton.classList.contains('beacon-toast__upside_down')) {
            collapseList(shadowRoot);
        }
        else {
            expandList(shadowRoot);
        }
    }
};
const addActionsToToast = (shadowRoot, toastConfig, list) => __awaiter(void 0, void 0, void 0, function* () {
    const actions = toastConfig.actions;
    if (actions && actions.length > 0) {
        const actionPromises = actions.map((action) => __awaiter(void 0, void 0, void 0, function* () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            return createActionItem(action);
        }));
        const actionItems = yield Promise.all(actionPromises);
        actionItems.forEach((item) => list.appendChild(item));
        const poweredByBeacon = document.createElement('small');
        poweredByBeacon.classList.add('beacon-toast__powered');
        poweredByBeacon.innerHTML = toastTemplates.default.poweredByBeacon;
        list.appendChild(poweredByBeacon);
    }
    else {
        showClose(shadowRoot);
        collapseList(shadowRoot);
    }
});
const createNewToast = (toastConfig) => __awaiter(void 0, void 0, void 0, function* () {
    globalToastConfig = toastConfig;
    const timer = toastConfig.timer;
    const shadowRootEl = document.createElement('div');
    shadowRootEl.setAttribute('id', 'beacon-toast-wrapper');
    const shadowRoot = shadowRootEl.attachShadow({ mode: 'open' });
    const wrapper = document.createElement('div');
    const { style, html } = getToastHTML(toastConfig);
    wrapper.innerHTML = html;
    const styleEl = document.createElement('style');
    styleEl.textContent = style;
    shadowRoot.appendChild(wrapper);
    shadowRoot.appendChild(styleEl);
    if (timer) {
        timeout = window.setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
            yield closeToast();
        }), timer);
    }
    document.body.prepend(shadowRootEl);
    const colorMode = getColorMode();
    const elm = shadowRoot.getElementById(`beacon-toast`);
    if (elm) {
        elm.classList.add(`theme__${colorMode}`);
    }
    const list = shadowRoot.getElementById('beacon-toast-list');
    if (list) {
        yield addActionsToToast(shadowRoot, toastConfig, list);
    }
    const openWalletButtonEl = shadowRoot.getElementById('beacon-open-wallet');
    if (openWalletButtonEl) {
        if (toastConfig.openWalletAction) {
            openWalletButtonEl.addEventListener('click', () => {
                if (toastConfig.openWalletAction) {
                    toastConfig.openWalletAction();
                }
            });
        }
        else {
            openWalletButtonEl.classList.add('hide');
        }
    }
    if (globalToastConfig.state === 'loading') {
        expandTimeout = window.setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
            const expandButton = shadowRoot.getElementById('beacon-toast-button-expand');
            if (expandButton && !expandButton.classList.contains('beacon-toast__upside_down')) {
                expandOrCollapseList(shadowRoot);
            }
        }), EXPAND_AFTER);
    }
    registerClick(shadowRoot, 'beacon-toast-button-done', () => __awaiter(void 0, void 0, void 0, function* () {
        yield closeToast();
    }));
    const closeButton = registerClick(shadowRoot, 'beacon-toast-button-close', () => __awaiter(void 0, void 0, void 0, function* () {
        yield closeToast();
    }));
    if (closeButton && globalToastConfig.state === 'loading') {
        closeButton.classList.add('hide');
    }
    registerClick(shadowRoot, 'beacon-toast-button-expand', () => __awaiter(void 0, void 0, void 0, function* () {
        expandOrCollapseList(shadowRoot);
    }));
});
const updateToast = (toastConfig) => __awaiter(void 0, void 0, void 0, function* () {
    globalToastConfig = Object.assign(Object.assign({}, globalToastConfig), toastConfig);
    const timer = toastConfig.timer;
    const wrapper = document.getElementById('beacon-toast-wrapper');
    if (!wrapper) {
        return;
    }
    const shadowRoot = wrapper.shadowRoot;
    if (!shadowRoot) {
        return;
    }
    const list = shadowRoot.getElementById('beacon-toast-list');
    if (list) {
        removeAllChildNodes(list);
        yield addActionsToToast(shadowRoot, toastConfig, list);
    }
    const toastTextEl = shadowRoot.getElementById('beacon-text');
    if (toastTextEl) {
        toastTextEl.innerHTML = formatToastText(toastConfig.body);
    }
    if (timer) {
        timeout = window.setTimeout(() => __awaiter(void 0, void 0, void 0, function* () {
            yield closeToast();
        }), timer);
    }
    const doneButton = shadowRoot.getElementById('beacon-toast-button-done');
    if (doneButton) {
        doneButton.addEventListener('click', () => __awaiter(void 0, void 0, void 0, function* () {
            yield closeToast();
        }));
    }
});
/**
 * Create a new toast
 *
 * @param toastConfig Configuration of the toast
 */
const openToast = (toastConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (expandTimeout) {
        clearTimeout(expandTimeout);
    }
    const wrapper = document.getElementById('beacon-toast-wrapper');
    if (wrapper) {
        if (toastConfig.forceNew) {
            yield closeToast();
            yield createNewToast(toastConfig);
        }
        else {
            yield updateToast(toastConfig);
        }
    }
    else {
        yield createNewToast(toastConfig);
    }
    if (globalToastConfig && globalToastConfig.state === 'finished') {
        const shadowRoot = (_a = document.getElementById('beacon-toast-wrapper')) === null || _a === void 0 ? void 0 : _a.shadowRoot;
        if (shadowRoot) {
            hideLoader(shadowRoot);
            showClose(shadowRoot);
            expandList(shadowRoot);
        }
    }
    return;
});
export { closeToast, openToast };
//# sourceMappingURL=Toast.js.map